import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Warehouses = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const millsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/mills',
    name: 'mills',
    component: Warehouses,
    meta: {
      title: 'Molinos',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
